import styled from 'styled-components';

export const DivRadio = styled.div`
  display: block;
  position: relative;
  padding-left: 30px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 18px;
    width: 18px;
    left: 0;
    z-index: 999;
  }
  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 3px;
    left: 0;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    border: 2px solid #666666;
  }
  &:hover input + span {
    background-color: #0669de;
  }
  > input:checked + span {
    border: none;
    background-color: #005cde;
  }
  > span:after {
    content: “”;
    position: absolute;
    display: none;
  }
  > input:checked + span:after {
    display: block;
  }
  &:after && span:after {
    left: 7px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;
